<template>
  <v-row>
    <v-col cols="12">
      <v-fade-transition mode="out-in">
        <project-loading
          v-if="loading.projectById == projectId"
        ></project-loading>

        <v-card v-else tile flat color="transparent" key="card">
          <v-card-title class="px-0 pt-0">
            <v-row align="center">
              <v-col>
                <div class="headline">
                  <router-link
                    class="project-name pb-1"
                    :to="{
                      name: 'project',
                      params: { project_id: project.id }
                    }"
                  >
                    {{ project.name }}
                  </router-link>
                  <span v-if="routeName" class="text-capitalize">
                    - {{ routeName.replace('_', ' ').replace('.', ' ') }}
                  </span>
                </div>
              </v-col>

              <v-col align="right">
                <v-layout class="d-block">
                  <v-btn
                    text
                    color="secondary"
                    class="ml-1"
                    :to="{
                      name: 'project.settings',
                      params: { project_id: project.id }
                    }"
                    v-if="$can('projects.settings')"
                    >Settings</v-btn
                  >
                  <v-btn
                    text
                    color="secondary"
                    class="ml-1"
                    :to="{
                      name: 'project.members',
                      params: { project_id: project.id }
                    }"
                    v-if="$can('projects.members')"
                    >Members</v-btn
                  >
                  <v-btn
                    text
                    color="secondary"
                    class="ml-1"
                    :to="{
                      name: 'project.documents',
                      params: { project_id: project.id }
                    }"
                    v-if="$can('projects.documents')"
                    >Documents</v-btn
                  >
                </v-layout>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pa-0">
            <v-fade-transition mode="out-in">
              <router-view></router-view>
            </v-fade-transition>
          </v-card-text>
        </v-card>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProjectLoading from '@/components/projects/ProjectLoading'

export default {
  name: 'Project',
  components: {
    ProjectLoading
  },
  computed: {
    ...mapGetters('projects', ['project', 'loading']),
    projectId() {
      return this.$route.params.project_id
    },
    routeName() {
      return this.$route.name !== 'project'
        ? this.$route.name.replace('project.', '')
        : ''
    }
  },
  methods: {
    ...mapActions('projects', ['fetchProject'])
  },
  created() {
    this.fetchProject(this.projectId)
  }
}
</script>

<style lang="scss">
.project-name {
  border-bottom: 1px solid;
}
</style>
